import { emailValidationRules, passwordValidationRules } from '@validation/rules/account';
export const accountRegisterValidationRules = {
  email: emailValidationRules,
  password: passwordValidationRules
};